import API from "./authApi";

export const sendOtp = async (
  email
) => {
  const response =
    await API.post(
      "/auth/send-otp",
      { email }
    );

  return response.data;
};

export const verifyOtp =
  async (email, otp) => {
    const response =
      await API.post(
        "/auth/verify-otp",
        {
          email,
          otp,
        }
      );

    return response.data;
  };

export const signup =
  async ({
    name,
    email,
    password,
  }) => {
    const response =
      await API.post(
        "/auth/signup",
        {
          name,
          email,
          password,
        }
      );

    return response.data;
  };

export const login =
  async (
    email,
    password
  ) => {
    const response =
      await API.post(
        "/auth/login",
        {
          email,
          password,
        }
      );

    return response.data;
  };